function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopyrightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.76 3.25c6.91 0 12.51 5.602 12.51 12.51 0 6.91-5.6 12.51-12.51 12.51-6.908 0-12.51-5.6-12.51-12.51 0-6.908 5.602-12.51 12.51-12.51z",
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.089 20.08a6.84 6.84 0 01-5.329 2.544 6.864 6.864 0 010-13.727 6.84 6.84 0 015.329 2.544",
    stroke: props.color,
    strokeWidth: 1.5
  }));
}

export default SvgIconCopyrightOutline;